var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeaf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.81 0H174V45.19C174 55.4831 169.911 65.3545 162.633 72.6328C155.355 79.9111 145.483 84 135.19 84H90V38.81C90 28.5169 94.0889 18.6455 101.367 11.3672C108.645 4.0889 118.517 0 128.81 0V0Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84 84H49.57C45.6868 84 41.8416 83.2351 38.2541 81.7491C34.6665 80.2631 31.4067 78.085 28.6609 75.3391C25.915 72.5933 23.7369 69.3335 22.2509 65.7459C20.7649 62.1584 20 58.3132 20 54.43V20L54.43 20C62.2725 20 69.7937 23.1154 75.3391 28.6609C80.8846 34.2063 84 41.7275 84 49.57V84Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.81 90H84V135.19C84 145.483 79.9111 155.355 72.6328 162.633C65.3545 169.911 55.4831 174 45.19 174H0V128.81C0 118.517 4.0889 108.645 11.3672 101.367C18.6455 94.0889 28.5169 90 38.81 90Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M200 200H140.82C127.342 200 114.415 194.646 104.885 185.115C95.3542 175.585 90 162.658 90 149.18L90 90L149.18 90C162.658 90 175.585 95.3542 185.115 104.885C194.646 114.415 200 127.342 200 140.82V200Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 98.31,
    y1: 82.43,
    x2: 167.32,
    y2: -0.380001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#019C85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEDC7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 82.51,
    y1: 81.58,
    x2: 26.98,
    y2: 27.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5DC7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 73.56,
    y1: 101.85,
    x2: 6.49,
    y2: 165.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEDC7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: -22282.2,
    y1: 10064.8,
    x2: -11303.1,
    y2: 21045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#019C85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEDC7C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.35e4399e41204586ed791dd82febdd5d.svg";
export { ForwardRef as ReactComponent };